import MeasurementService from "src/services/MeasurementService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {
	UPDATE_ROW: "measurement/update-row",
	DUPLICATE: "measurement/duplicate",
	FORCE_REMOVE: "measurement/force_remove",
	MULTI_UPDATE: "measurement/multi_update",
	DONE: "measurement/done",
	CANCEL: "measurement/cancel",
  RENEW: "measurement/renew"
};
export const params = {
	order_id: "",
	multimeter_id: "",
	areas: "",
	note: "",
	status: "",
	when: "",
	multimeter_notes: "",
	has_floor: "",
	has_plaster: "",
	confirm_floor: "",
	confirm_plaster: "",
	has_electric: "",
	confirm_electric: "",
	surveyor_notes: "",
	internal_note: "",
	additional_price: "",

};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.measurement,
@property  {array}  modules.measurements
 **/

const module1 = {
	state: {},
	mutations: {
		[types.UPDATE_ROW](state, item) {
			state.measurement = item;
		},
    [types.RENEW](state,item){

      state.measurements = MeasurementService.UpdateArrayById(state.measurements,item);

    }
	},
	getters: {},
	actions: {
		async [types.DUPLICATE](ctx, duplicate) {

			let measurement = await MeasurementService.duplicate(duplicate.id, duplicate.form);
			if (!duplicate.deleted_at) {
				ctx.commit(types.STORE, measurement);
			}
			return measurement;
		},
    async [types.RENEW](ctx, renew) {

			let measurement = await MeasurementService.renew(renew.id, renew.form);

				 ctx.commit(types.RENEW, measurement);

			return measurement;

		},

		async [types.FORCE_REMOVE](ctx, item) {
			let response = await MeasurementService.forceDelete(item.id);
			ctx.commit(types.REMOVE, item);
			return response;
		},
		async [types.MULTI_UPDATE](ctx, form) {
			return MeasurementService.multiUpdate(form);
		},
		async [types.DONE](ctx, form) {
			let measurements = await MeasurementService.done(form);
			measurements.forEach((m) => {
				ctx.commit(types.UPDATE, m);
			});
			return measurements;

		},
		async [types.CANCEL](ctx, form) {
			let measurements = await MeasurementService.cancel(form);
			measurements.forEach((m) => {
				ctx.commit(types.UPDATE, m);
			});
			return measurements;
		}
	},
	types: types
};
export default ModuleCreator("measurement", MeasurementService, module1, types, params);
